import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs'; 
import { ComboData } from '../models/user';
import { SnackbarService } from './snackbar.service';
import { Router } from '@angular/router';
declare let $: any;
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  breadcrum: { label: string, route?: string }[] = [];
  isShowHeaderAlso:string=null;
  customKeys:{[key:string]:string} = {
    'First Name':'firstname',
    'Last Name':'lastname',
    'Email Signature':'ai-email-signature'
  }; 

  private _trackingId;
  public get trackingId(){
    return this._trackingId;
  }

  private _isBreadcrum: Subject<boolean> = new Subject();
  public $isBreadcrum: Observable<boolean> = this._isBreadcrum.asObservable();
  
  private _refresh: Subject<boolean> = new Subject();
  public $refreshData: Observable<boolean> = this._refresh.asObservable();
  
  private _isProspect: Subject<boolean> = new Subject();
  public $isProspect: Observable<boolean> = this._isProspect.asObservable();

  private _isDomain: Subject<boolean> = new Subject();
  public $isDomain: Observable<boolean> = this._isDomain.asObservable();

  constructor(private snack:SnackbarService, private router: Router) { }

  openSnacbar(val:string){
    this.snack.show(val);
  }

  breadCrumSet(){
    this._isBreadcrum.next(true);
  }

  navigateToBreadcrumb(index: number) {
    const crumb = this.breadcrum[index];
    if (crumb && crumb.route) {
      this.router.navigate([crumb.route]);
    }
  }

  IsProspectSet(){
    this._isProspect.next(true);
  }

  isDomainSet(){
    this._isDomain.next(true);
  }
  
  isDomainResSet(){
    this._isDomain.next(false);
  }

  getChangedProperties(formGroup: FormGroup): any {
    const changedProperties: any = {};
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control?.dirty) {
        changedProperties[key] = control.value;
      }
    });
    return changedProperties;
  }

  refreshData(){
    this._refresh.next(true);
  }

  serRandomTrackingId(){
    this._trackingId = `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`; 
  }

  transformToComboData(lstData:string[],dataObject:ComboData[]){
    lstData.forEach(v=>{
      dataObject.push(new ComboData(v,v));
    });
  }

  setMinimalSummarNote(){
    setTimeout(() => {
      const customDropdownButton = (context: any) => {
        const ui = $.summernote.ui;

        const dropdownContent = Object.entries(this.customKeys).map(([key, value]) => {
          return ui.button({
            contents: `<div class="dropdown-item-wrapper">
                        <span class="dropdown-item-text">${key}</span>
                      </div>`,
            click: () => {
              $('#summernoteminimal').summernote('pasteHTML', `${value}`);
            }
          });
        });
    
        const dropdown = ui.dropdown(dropdownContent);
    
        const button = ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle btn btn-light merge-keys-btn',
            contents: '<i class="note-icon-magic"></i> Merge Keys <span class="caret"></span>',
            tooltip: 'Insert placeholders like {{Name}} into the editor',
            data: {
              toggle: 'dropdown'
            }
          }),
          dropdown
        ]);
    
        return button.render();
      };
    
      $('#summernoteminimal').summernote({
        height: 100,
        toolbar: [
          ['custom', ['customDropdown']]
        ],
        buttons: {
          customDropdown: customDropdownButton
        }
      });

      // Add custom CSS for the dropdown
      const style = document.createElement('style');
      style.textContent = `
        .dropdown-item-wrapper {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 6px 10px;
          width: 100%;
          max-width: 180px;
          gap: 8px;
          box-sizing: border-box;
        }
        .dropdown-item-text {
          color: #333;
          font-weight: 500;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 13px;
          margin: 0;
          padding: 0;
          min-width: 0;
        }
        .merge-keys-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: #fff;
          color: #333;
          transition: all 0.2s ease;
          font-size: 13px;
          height: 28px;
          min-width: 120px;
          margin: 0;
        }
        .merge-keys-btn:hover {
          background: #f5f5f5;
          border-color: #ccc;
        }
        .note-dropdown-menu {
          padding: 4px 0;
          border-radius: 4px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          max-height: 250px;
          overflow-y: auto;
          min-width: 200px;
          width: 200px;
        }
        .note-dropdown-menu .note-btn{
        width: 100%;
        }
        .note-dropdown-menu::-webkit-scrollbar {
          width: 6px;
        }
        .note-dropdown-menu::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        .note-dropdown-menu::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }
        .note-dropdown-menu::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .note-dropdown-menu .note-dropdown-item {
          padding: 0;
          margin: 0;
          border-bottom: 1px solid #eee;
          width: 100%;
          display: block;
          clear: both;
        }
        .note-dropdown-menu .note-dropdown-item:last-child {
          border-bottom: none;
        }
        .note-dropdown-menu .note-dropdown-item:hover {
          background: #f8f9fa;
        }
        .note-dropdown-menu .note-dropdown-item button {
          width: 100%;
          text-align: center;
          padding: 8px 10px;
          border: none;
          background: none;
          cursor: pointer;
          display: block;
          height: 36px;
          box-sizing: border-box;
          line-height: 20px;
        }
        .note-dropdown-menu .note-dropdown-item button:hover {
          background: #f8f9fa;
        }
        .note-dropdown-menu .dropdown-item-wrapper {
          width: 100%;
          max-width: none;
          justify-content: center;
        }
      `;
      document.head.appendChild(style);
    }, 100);
  }

  setSummarNote(){
    setTimeout(() => {
      const customDropdownButton = (context: any) => {
        const ui = $.summernote.ui;

        const dropdownContent = Object.entries(this.customKeys).map(([key, value]) => {
          return ui.button({
            contents: `<div class="dropdown-item-wrapper">
                        <span class="dropdown-item-text">${key}</span>
                      </div>`,
            click: () => {
              $('#summernote').summernote('pasteHTML', `${value}`);
            }
          });
        });
    
        const dropdown = ui.dropdown(dropdownContent);
    
        const button = ui.buttonGroup([
          ui.button({
            className: 'dropdown-toggle btn btn-light merge-keys-btn',
            contents: '<i class="note-icon-magic"></i> Merge Keys <span class="caret"></span>',
            tooltip: 'Insert placeholders like {{Name}} into the editor',
            data: {
              toggle: 'dropdown'
            }
          }),
          dropdown
        ]);
    
        return button.render();
      };
    
      $('#summernote').summernote({
        height: 200,
        toolbar: [
          ['style', ['style']],
          ['font', ['bold', 'italic', 'underline', 'clear']],
          ['fontname', ['fontname']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']],
          ['table', ['table']],
          ['insert', ['link', 'picture', 'video']],
          ['view', ['fullscreen', 'codeview', 'help']],
          ['custom', ['customDropdown']]
        ],
        buttons: {
          customDropdown: customDropdownButton
        }
      });

      // Add custom CSS for the dropdown
      const style = document.createElement('style');
      style.textContent = `
        .dropdown-item-wrapper {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 6px 10px;
          width: 100%;
          max-width: 180px;
          gap: 8px;
          box-sizing: border-box;
        }
        .dropdown-item-text {
          color: #333;
          font-weight: 500;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 13px;
          margin: 0;
          padding: 0;
          min-width: 0;
        }
        .merge-keys-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: #fff;
          color: #333;
          transition: all 0.2s ease;
          font-size: 13px;
          height: 28px;
          min-width: 120px;
          margin: 0;
        }
        .merge-keys-btn:hover {
          background: #f5f5f5;
          border-color: #ccc;
        }
        .note-dropdown-menu {
          padding: 4px 0;
          border-radius: 4px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          max-height: 250px;
          overflow-y: auto;
          min-width: 200px;
          width: 200px;
        }
        .note-dropdown-menu .note-btn{
        width: 100%;
        }
        .note-dropdown-menu::-webkit-scrollbar {
          width: 6px;
        }
        .note-dropdown-menu::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        .note-dropdown-menu::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }
        .note-dropdown-menu::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .note-dropdown-menu .note-dropdown-item {
          padding: 0;
          margin: 0;
          border-bottom: 1px solid #eee;
          width: 100%;
          display: block;
          clear: both;
        }
        .note-dropdown-menu .note-dropdown-item:last-child {
          border-bottom: none;
        }
        .note-dropdown-menu .note-dropdown-item:hover {
          background: #f8f9fa;
        }
        .note-dropdown-menu .note-dropdown-item button {
          width: 100%;
          text-align: center;
          padding: 8px 10px;
          border: none;
          background: none;
          cursor: pointer;
          display: block;
          height: 36px;
          box-sizing: border-box;
          line-height: 20px;
        }
        .note-dropdown-menu .note-dropdown-item button:hover {
          background: #f8f9fa;
        }
        .note-dropdown-menu .dropdown-item-wrapper {
          width: 100%;
          max-width: none;
          justify-content: center;
        }
      `;
      document.head.appendChild(style);
    }, 100);
  }

  getContent() {
    return $('#summernote').summernote('code'); 
  }

  getPlainContent() {
    const htmlContent = $('#summernoteminimal').summernote('code');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText;
  }

  getPlainHtmlContent() {
    const htmlContent = $('#summernote').summernote('code');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText;
  }
}